<template>
    <div class="marketTextholder" v-if="marketName !== 'Match Winner'">
        <div :class="{'disableText':(marketDetail.marketDetailStatus !== 1 || marketStatusId !== 1 || marketDetail.marketDetailOdd === 0),'marketName':(true)}">{{marketDetail.marketDetailName}}</div>
        <div v-if="marketDetail.marketDetailStatus !== 1 || marketStatusId !== 1 || marketDetail.marketDetailOdd === 0" :class="{'lock':(true)}"><i class="material-icons lock-icon">lock</i></div>
        <div v-else :class="{'disableText':(marketDetail.marketDetailStatus !== 1 || marketStatusId !== 1 || marketDetail.marketDetailOdd === 0),'odd':(true)}">{{marketDetail.marketDetailOdd}}</div>
    </div>
</template>

<script>
    export default {
        name: 'Market',
        props: {
            marketName: String,
            marketDetail: Object,
            marketStatusId: Number
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .disableText {
        text-decoration: line-through !important;
    }

    .marketTextholder {
        width: 100%;
        display: inline-block;
        text-overflow: ellipsis;
        overflow: visible;
        height: 36px !important;
    }

    .v-btn.v-btn--flat.theme--dark.info--text .marketTextholder {
        border-bottom: 0px solid #000 !important;
    }



    .marketName {
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        width: calc(100% - 43px);
        font-size: 11px;
    }

    .odd {
        color: gold;
        display: inline-block;
        width: 43px;
        position: relative;
    }

    .lock {
        color: white;
        display: inline-block;
        position: relative;
    }

        .lock .material-icons {
            font-size: 15px;
        }
</style>
